import { BodyText, LabelText, Row } from '@policygenius/mortar';
import styled from 'styled-components';
import { suisseIntl, victorSerif } from '../typography';

export const Background = styled.div`
  background-color: #f7f5f3;
  padding: 0 16px;
`;

export const Grid = styled(Row)`
  padding-top: 48px;
  padding-bottom: 48px;
  margin: auto;
`;

export const Header = styled(LabelText)`
  ${victorSerif()};
  font-size: 28px;
  line-height: 1.1;
  margin-bottom: 16px;
  color: #131212;
`;

export const SectionOneText = styled(BodyText)`
  ${suisseIntl()};
  margin-bottom: 16px;
  color: #131212;
`;

export const DisclosuresLink = styled(BodyText)`
  ${suisseIntl()};
  text-decoration: underline;
  color: #131212;
  cursor: pointer;
  &:hover {
    color: #d44414;
  }
`;
